import React from 'react'
import moment from 'moment'
import {RRule} from 'rrule'

import SubscriptionActions from '../../actions/SubscriptionActions.js'

import {Link, Spinner, Alert, Button, Colors, Modal, ModalActions, S2, P, ScrollView} from '../UI/index.js'
import SelectCustomer from '../customers/SelectCustomer.js'
import {formSpacing, FormRow, FormStack, Input, TextArea, CurrencyInput, DatePicker, Check, Recurrence} from '../UI/forms/index.js'
import NewSubscription from './NewSubscription.js'

class SubscriptionModal extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            modalIsOpen: false,
            subscriptionLoading: false,
            subscriptionError: null,
            subscription: NewSubscription(),
            firstInvoiceDate: moment().format('YYYY-MM-DD'),
            error: '',
            loading: false
        }

        this.state = structuredClone(this.initialState)
    }

    open(id) {
        if (id) {
            id = id.split(' ')[0]

            this.setState({modalIsOpen: true, subscriptionLoading: true})

            SubscriptionActions.getOne(id, (err, subscription) => {
                if (err) {
                    this.setState({subscriptionLoading: false, subscriptionError: err})
                } else {
                    console.log(subscription)

                    this.setState({
                        subscriptionLoading: false,
                        subscriptionError: null,
                        subscription,
                        firstInvoiceDate: moment(RRule.fromString(subscription.rrule).options.dtstart).format('YYYY-MM-DD')
                    })
                }
            })
        } else {
            this.setState({modalIsOpen: true}, () => {
                const subscription = NewSubscription()
                subscription.rrule = this.recurrence.init()

                this.setState({subscription})
            })
        }
    }

    close() {
        this.setState(this.initialState)
    }

    onChangeCustomer({customer}) {
        if (customer) {
            const subscription = {...this.state.subscription}

            subscription.customer = customer._id

            this.setState({subscription})
        }
    }

    onChangeValue(key, event) {
        const {subscription} = this.state
        subscription[key] = event.target.value
        this.setState({subscription})
    }

    onChangeNoEndDate(event) {
        const {subscription} = this.state

        if (event.target.checked) {
            subscription.endDate = '2999-12-31'
        } else {
            subscription.endDate = moment().format('YYYY-MM-DD')
        }

        this.setState({subscription})
    }

    onSubmit(event) {
        event.preventDefault()
        const {subscription} = this.state
        const customerValid = !this.selectCustomer || this.selectCustomer.validate()

        if (customerValid) {
            this.setState({loading: true, error: ''})

            if (subscription._id) {
                SubscriptionActions.edit(subscription, this.response.bind(this))
            } else {
                SubscriptionActions.create(subscription, this.response.bind(this))
            }
        }
    }

    response(err) {
        if (err) {
            this.setState({loading: false, error: err})
        } else {
            this.close()
        }
    }

    render() {
        const {modalIsOpen, subscriptionLoading, subscriptionError, subscription, firstInvoiceDate, error, loading} = this.state
        const {history, customers} = this.props

        return (
            <Modal
                show={modalIsOpen}
                title={subscription?._id ? 'Abonnement info' : 'Nieuw Abonnement'}
                onClose={this.close.bind(this)}
                closeButton
            >

                {subscriptionLoading ?
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 250}}>
                        <Spinner color={Colors.textDark} />
                    </div> :
                    <>
                        <form onSubmit={this.onSubmit.bind(this)}>
                            <FormStack style={{marginBottom: formSpacing.rowGap}}>
                                <FormRow>
                                    <FormStack style={{flex: 1}}>
                                        <SelectCustomer
                                            value={subscription.customer}
                                            customers={customers}
                                            onChange={this.onChangeCustomer.bind(this)}
                                            ref={(ref) => this.selectCustomer = ref}
                                        />
                                    </FormStack>

                                    <Input
                                        label='Referentie'
                                        value={subscription.reference}
                                        onChange={this.onChangeValue.bind(this, 'reference')}
                                    />
                                </FormRow>

                                <FormRow>
                                    <Input
                                        label='Omschrijving'
                                        value={subscription.description}
                                        onChange={this.onChangeValue.bind(this, 'description')}
                                    />

                                    <CurrencyInput
                                        label='prijs'
                                        value={subscription.price}
                                        onChange={this.onChangeValue.bind(this, 'price')}
                                    />
                                </FormRow>

                                <FormRow style={{marginTop: formSpacing.rowGap}}>
                                    <DatePicker
                                        disabled={subscription._id}
                                        label='Eerste factuur datum'
                                        value={firstInvoiceDate}
                                        onChange={(event) => this.setState({firstInvoiceDate: event.target.value})}
                                    />

                                    <FormStack style={{flex: 1}}>
                                        <Recurrence
                                            type='subscription'
                                            rrule={subscription.rrule}
                                            date={firstInvoiceDate}
                                            onChange={this.onChangeValue.bind(this, 'rrule')}
                                            disabled={!!subscription._id}
                                            ref={(ref) => this.recurrence = ref}
                                        />
                                    </FormStack>
                                </FormRow>

                                <FormRow>
                                    <DatePicker
                                        label='Begindatum'
                                        value={subscription.startDate}
                                        disabled={subscription._id}
                                        onChange={this.onChangeValue.bind(this, 'startDate')}
                                    />

                                    <DatePicker
                                        label='Einddatum'
                                        value={subscription.endDate}
                                        disabled={subscription.endDate === '2999-12-31'}
                                        onChange={this.onChangeValue.bind(this, 'endDate')}
                                    />
                                </FormRow>

                                <FormRow style={{marginTop: -6}}>
                                    <div style={{flex: 1}} />
                                    <Check
                                        label='Geen einddatum'
                                        checked={subscription.endDate === '2999-12-31'}
                                        onChange={this.onChangeNoEndDate.bind(this)}
                                    />
                                </FormRow>

                                <FormRow style={{marginTop: formSpacing.rowGap}}>
                                    <TextArea
                                        rows={3}
                                        label='Opmerkingen'
                                        value={subscription.notes}
                                        onChange={this.onChangeValue.bind(this, 'notes')}
                                    />
                                </FormRow>
                            </FormStack>

                            {subscription._id && subscription.history &&
                                <ScrollView style={{marginTop: 24, maxHeight: 250}}>
                                    {[...subscription.history].reverse().map((entry, index) => {
                                        return (
                                            <div key={`history${index}`} style={{display: 'flex', alignItems: 'center', padding: 5}}>
                                                <div style={{height: 15, width: 15, borderRadius: '50%', marginRight: 15, background: Colors.grey20}} />
                                                <div style={{flex: 1}}>
                                                    {entry.type === 'invoice' ?
                                                        <Link onClick={() => history.push('/facturatie', {invoiceId: entry.invoiceId})}>{entry.description}</Link> :
                                                        <P>{entry.description}</P>
                                                    }
                                                </div>
                                                <S2 style={{marginRight: 15}}>{`${entry.who} | ${entry.timestamp ? moment(entry.timestamp).format('DD-MM-YYYY HH:mm:ss') : entry.time}`}</S2>
                                            </div>
                                        )
                                    })}
                                </ScrollView>
                            }

                            {error && <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>}

                            <ModalActions>
                                <Button loading={loading} type='submit'>Opslaan</Button>
                            </ModalActions>
                        </form>
                    </>
                }

                {subscriptionError &&
                    <Alert style={{marginBottom: 6}} variant='danger'>{subscriptionError}</Alert>
                }
            </Modal>
        )
    }
}

export default (SubscriptionModal)
